export var createClassListFromModifiers = function (baseClass, modifier) {
    if (!modifier) {
        return [];
    }
    var classList = [];
    if ('string' === typeof modifier) {
        classList.push(baseClass + "--" + modifier);
    }
    if (Array.isArray(modifier)) {
        modifier.filter(function (v) { return v; }).forEach(function (m) { return classList.push(baseClass + "--" + m); });
    }
    return classList;
};
